import { Stack, Typography } from "@mui/material";
import { useTranslation } from "@privacy/translations";
import type { InviteConversation } from "../../../api/assistant";
import { inviteApproveCommitMutationOptions, inviteSendMessageMutationOptions } from "../../../api/assistant";
import { SparklesIcon } from "../../../shared/icons";
import { AssistantChat } from "../AssistantChat";
import type { AssistantApi } from "../AssistantApiContext";
import { AssistantApiContext } from "../AssistantApiContext";
import { CHAT_CONTENT_WIDTH } from "../assistantChatLayout";

type InviteChatProps = { invitationId: string; conversation: InviteConversation; organisationName: string };

export const InviteChat = ({ invitationId, conversation, organisationName }: InviteChatProps) => {
  const { t } = useTranslation();
  const { invitation } = conversation;

  const assistantApi: AssistantApi = {
    sendMessageMutationOptions: () => inviteSendMessageMutationOptions(invitationId),
    approveCommitMutationOptions: () => inviteApproveCommitMutationOptions(invitationId),
    firstMessage: t("Assistant.Invite.FirstMessage", { inviter: invitation.inviterName }),
    displayName: invitation.reporterEmail,
    defaultUnitName: organisationName,
    isInvite: true,
  };

  return (
    <AssistantApiContext value={assistantApi}>
      <Stack sx={{ height: "100dvh", minHeight: 0 }}>
        <Stack sx={{ px: 3, py: 2, borderBottom: theme => `1px solid ${theme.palette.divider}` }}>
          <Stack sx={{ gap: 0.5, width: "100%", maxWidth: CHAT_CONTENT_WIDTH, mx: "auto", px: 1 }}>
            <Stack direction="row" sx={{ alignItems: "center", gap: 1 }}>
              <SparklesIcon size={16} />
              <Typography sx={{ fontWeight: 600, fontSize: theme => theme.typography.pxToRem(14) }}>
                {t("Assistant.Invite.Request", { inviter: invitation.inviterName })}
              </Typography>
            </Stack>
            <Typography sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>{invitation.reason}</Typography>
          </Stack>
        </Stack>
        <AssistantChat
          conversation={conversation}
          closedMessage={
            invitation.status === "submitted"
              ? t("Assistant.Invite.Thanks", { inviter: invitation.inviterName })
              : undefined
          }
        />
      </Stack>
    </AssistantApiContext>
  );
};
